const seoFragment = `#graphql
  fragment seo on SEO {
    description
    title
  }
`

export { seoFragment }
